import  './PressureSensorPch.css';

export default function PressureSensorPch({percent, pmax, islink}) {

    const formatPressurePch = (percent, pmax, decimalPlaces = 1, unit = 'Бар') => {

        if (percent == null || pmax == null) {
            return '...';
        }
        // Преобразуем в числа, удаляя возможные пробелы
        const percentNum = parseFloat(String(percent).trim());
        const pmaxNum = parseFloat(String(pmax).trim());
        // const pmaxNum = pmax;
        // Проверяем, что оба значения являются корректными числами
        if (isNaN(percentNum) || isNaN(pmaxNum) || pmaxNum <= 0) {
            return '...';
        }
        // Преобразуем "значение с десятыми" в проценты
        const percentValue = percentNum / 10; // 434 -> 43.4
        // Проверяем, что проценты в допустимом диапазоне (0-100%)
        if (percentValue < 0 || percentValue > 100) {
            return '...';
        }
         // Вычисляем давление
        const pressure = pmaxNum * (percentValue / 100);
        return `${pressure.toFixed(decimalPlaces)} ${unit}`;
    };

    const pressurePch = formatPressurePch(percent, pmax, 2,'Бар')
    return(
       
        <div className='PressureSensorPch'>
            {islink==='Online' && (
                <div>P: {pressurePch}</div>
            )}              
        </div>
    )
}